const checkPlanOnCAA = (userPlan: TUserPlan): boolean =>
  userPlan === 'Demo' || userPlan === 'Plus' || userPlan === 'Enterprise';

export default checkPlanOnCAA;
